"use client";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { Col, Form, Input, Row, Select, Switch, Typography } from "antd";

const { Text } = Typography;

const TaxAndCharges = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    checkedSetup,
    setCheckedSetup,
    checkedRedemption,
    setCheckedRedemption,
    checkedTransfer,
    setCheckedTransfer,
    checkedBrokerage,
    setCheckedBrokerage,
    chargeOptions,
    taxGroupOptions,
    checkedTaxGroup,
    setCheckedTaxGroup,
  } = props;

  const handleSetupChange = (checked) => {
    setCheckedSetup(checked);
  };
  const handleRedemptionChange = (checked) => {
    setCheckedRedemption(checked);
  };
  const handleTransferChange = (checked) => {
    setCheckedTransfer(checked);
  };
  const handleBrokerageChange = (checked) => {
    setCheckedBrokerage(checked);
  };
  const handleTaxGroupChange = (checked) => {
    setCheckedTaxGroup(checked);
  };

  const chargesOptions = chargeOptions
    ?.filter(
      (option) =>
        option.active === true &&
        option.chargeAppliesTo?.toLowerCase() === "treasury"
    )
    .map((option) => ({
      value: option.value,
      label: option.label,
      chargeTimeType: option?.chargeTimeType,
    }));

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Tax & Charges
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={13} style={{ padding: "0px 8px" }}>
            <Row
              style={{
                marginTop: 20,
                marginBottom: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Switch
                  onClick={props.onSwitchClick}
                  checked={checkedTaxGroup}
                  onChange={handleTaxGroupChange}
                  style={{
                    backgroundColor: checkedTaxGroup ? "#b026ff" : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Tax Group
                </Text>
              </div>

              {checkedTaxGroup && (
                <Form.Item
                  name="taxGroup"
                  style={{ display: "flex", alignItems: "center", margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select tax group",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Tax Group"
                    style={{ width: 220, height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={taxGroupOptions}
                    virtual={false}
                  />
                </Form.Item>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={13} style={{ padding: "0px 8px" }}>
            <Row
              style={{
                marginTop: 20,
                marginBottom: 20,
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div>
                <Switch
                  onClick={props.onSwitchClick}
                  checked={checkedSetup}
                  onChange={handleSetupChange}
                  style={{
                    backgroundColor: checkedSetup ? "#b026ff" : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Processing Charges
                </Text>
              </div>

              {checkedSetup && (
                <Form.Item
                  name="setupCharges"
                  style={{ display: "flex", alignItems: "center", margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select charge",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Charges"
                    style={{ width: 220, height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={chargesOptions
                      ?.filter(
                        (option) =>
                          option.chargeTimeType?.toLowerCase() ===
                          "deal activation"
                      )
                      .map((option) => ({
                        value: option.value,
                        label: option.label,
                      }))}
                  />
                </Form.Item>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={13} style={{ padding: "0px 8px" }}>
            <Row
              style={{
                marginTop: 20,
                marginBottom: 20,
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div>
                <Switch
                  onClick={props.onSwitchClick}
                  checked={checkedRedemption}
                  onChange={handleRedemptionChange}
                  style={{
                    backgroundColor: checkedRedemption ? "#b026ff" : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Redemption Charges
                </Text>
              </div>

              {checkedRedemption && (
                <Form.Item
                  name="redemptionCharges"
                  style={{ display: "flex", alignItems: "center", margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select charge",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Charges"
                    style={{ width: 220, height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={chargesOptions
                      ?.filter(
                        (option) =>
                          option.chargeTimeType?.toLowerCase() === "redemption"
                      )
                      .map((option) => ({
                        value: option.value,
                        label: option.label,
                      }))}
                  />
                </Form.Item>
              )}
            </Row>
          </Col>
        </Row>
        {/* <Row>
          <Col span={13} style={{ padding: "0px 8px" }}>
            <Row
              style={{
                marginTop: 20,
                marginBottom: 20,
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div>
                <Switch
                  onClick={props.onSwitchClick}
                  checked={checkedTransfer}
                  onChange={handleTransferChange}
                  style={{
                    backgroundColor: checkedTransfer ? "#b026ff" : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Stamp Duty Charges
                </Text>
              </div>

              {checkedTransfer && (
                <Form.Item
                  name="transferCharges"
                  style={{ display: "flex", alignItems: "center", margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select charge",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Charges"
                    style={{ width: 220, height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={chargesOptions}
                  />
                </Form.Item>
              )}
            </Row>
          </Col>
        </Row> */}
        {/* <Row>
          <Col span={13} style={{ padding: "0px 8px" }}>
            <Row
              style={{
                marginTop: 20,
                marginBottom: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Switch
                  onClick={props.onSwitchClick}
                  checked={checkedBrokerage}
                  onChange={handleBrokerageChange}
                  style={{
                    backgroundColor: checkedBrokerage ? "#b026ff" : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Brokerage/Agent Commission
                </Text>
              </div>

              {checkedBrokerage && (
                <Form.Item
                  name="commission"
                  style={{ display: "flex", alignItems: "center", margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Commission is required",
                    },
                    {
                      pattern: /^\d+$/,
                      message: "Commission must be a number",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Charges"
                    style={{ width: 220, height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={chargesOptions}
                  />
                </Form.Item>
              )}
            </Row>
          </Col>
        </Row> */}
      </Form>
    </div>
  );
};

export default TaxAndCharges;
